if (!customElements.get('locations-map')) {
    class LocationsMap extends HTMLElement {
        connectedCallback() {
            let dataScript = this.querySelector('script[type="application/json"]');
            if (!dataScript) return;

            let config;
            try {
                config = JSON.parse(dataScript.textContent);
            } catch (e) {
                console.error('LocationsMap: invalid JSON config', e);
                return;
            }

            let locations = config.locations;
            let mapPinIconUrl = config.mapPinIconUrl || null;
            let mapPinIconHtml = config.mapPinIcon || null;
            if (!locations || locations.length === 0) return;

            let self = this;

            ((g) => {
                let h, a, k, p = 'The Google Maps JavaScript API', c = 'google', l = 'importLibrary', q = '__ib__', m = document, b = window;
                b = b[c] || (b[c] = {}); let d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(),
                    u = () => h || (h = new Promise(async (f, n) => {
                        await (a = m.createElement('script'));
                        e.set('libraries', [...r] + ''); for (k in g) e.set(k.replace(/[A-Z]/g, t => '_' + t[0].toLowerCase()), g[k]);
                        e.set('callback', c + '.maps.' + q); a.src = `https://maps.${c}apis.com/maps/api/js?` + e; d[q] = f;
                        a.onerror = () => (h = n(Error(p + ' could not load.'))); a.nonce = m.querySelector('script[nonce]')?.nonce || '';
                        m.head.append(a)
                    }));
                d[l] ? console.warn(p + ' only loads once. Ignoring:', g) : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
            })({ key: config.apiKey, v: 'weekly' });

            this._initMap(locations, mapPinIconUrl, mapPinIconHtml, config);
        }

        async _detectCountry() {
            try {
                let params = new URLSearchParams({ 'country[enabled]': 'true' });
                let res = await fetch('/browsing_context_suggestions.json?' + params.toString(), {
                    headers: { Accept: 'application/json' }
                });
                if (!res.ok) return null;
                let data = await res.json();
                let country = data && data.detected_values && data.detected_values.country;
                let handle = country && country.handle;
                if (handle) return handle;
            } catch (e) {
            }
            return null;
        }

        async _loadCentroids(url) {
            try {
                let res = await fetch(url);
                if (!res.ok) return null;
                return await res.json();
            } catch (e) {
                return null;
            }
        }

        async _initMap(locations, mapPinIconUrl, mapPinIconHtml, config) {
            let self = this;

            let isMobile = window.matchMedia && window.matchMedia('(max-width: 798px)').matches;
            let center = { lat: locations[0].lat, lng: locations[0].lng };

            let zoom;
            if (isMobile) {
                let z = parseInt(config && config.startZoomMobile, 10);
                zoom = isFinite(z) ? z : 3;
            } else {
                let z = parseInt(config && config.startZoom, 10);
                zoom = isFinite(z) ? z : 5;
            }

            let autoLocate = !config || config.autoLocate !== false;
            let countryPromise = autoLocate ? self._detectCountry() : null;
            let centroidsPromise = (autoLocate && config && config.centroidsUrl) ? self._loadCentroids(config.centroidsUrl) : null;

            let [{ Map }, { AdvancedMarkerElement }, { InfoWindow }] = await Promise.all([
                google.maps.importLibrary('maps'),
                google.maps.importLibrary('marker'),
                google.maps.importLibrary('maps')
            ]);

            let mapEl = this.querySelector('[data-locations-map]');
            if (!mapEl) return;

            let countryApplied = false;

            // Priority 1: visitor's country centre.
            if (countryPromise && centroidsPromise) {
                let country = await countryPromise;
                let centroids = await centroidsPromise;
                let entry = country && centroids ? centroids[country] : null;
                if (entry && isFinite(entry.lat) && isFinite(entry.lng)) {
                    center = { lat: entry.lat, lng: entry.lng };
                    let cz = isMobile ? entry.zoomMobile : entry.zoom;
                    if (isFinite(cz)) zoom = cz;
                    countryApplied = true;
                }
            }

            // Priority 2: merchant-set coordinates from the customizer.
            if (!countryApplied) {
                let startLat = parseFloat(config && config.startLat);
                let startLng = parseFloat(config && config.startLng);
                if (isFinite(startLat) && isFinite(startLng)) {
                    center = { lat: startLat, lng: startLng };
                }
            }

            // Priority 3: first location (the default centre set above).

            let map = new Map(mapEl, {
                center: center,
                zoom: zoom,
                mapTypeControl: false,
                streetViewControl: false,
                mapId: 'SIFLY_MAP_ID'
            });

            let infoWindow = new InfoWindow();
            let markers = [];

            function createInfoWindowContent(loc) {
                let wrapper = document.createElement('div');
                wrapper.className = 'store-info-iw';
                let body = '<strong class="caption-14-semibold">' + loc.title + '</strong>';
                if (loc.address) body += '<br><small class="store-info-card-marker__address">' + loc.address + '</small><br>';
                if (loc.phone) body += '<br><small class="store-info-card-marker__phone">' + loc.phone + '</small>';
                wrapper.innerHTML = '<button type="button" class="store-info-iw__close" aria-label="Close">&times;</button><div>' + body + '</div>';
                let closeBtn = wrapper.querySelector('.store-info-iw__close');
                closeBtn.addEventListener('click', function () { infoWindow.close(); });
                return wrapper;
            }

            function openLocationPopup(loc, marker, options) {
                options = options || {};
                markers.forEach(function (m) {
                    if (m.content && m.content.querySelectorAll) {
                        m.content.querySelectorAll('path').forEach(function (p) { p.style.fill = ''; });
                    }
                });
                if (marker.content && marker.content.querySelectorAll) {
                    marker.content.querySelectorAll('path').forEach(function (p) { p.style.fill = '#C5222B'; });
                }
                if (options.panAndZoom) {
                    map.panTo({ lat: loc.lat, lng: loc.lng });
                    map.setZoom(12);
                }
                infoWindow.close();
                infoWindow.setContent(createInfoWindowContent(loc));
                infoWindow.open(map, marker);
            }

            let pinContentTemplate = null;
            let pinIsImg = false;

            if (mapPinIconUrl) {
                try {
                    let resp = await fetch(mapPinIconUrl);
                    let text = await resp.text();
                    let ct = (resp.headers.get('content-type') || '').toLowerCase();
                    if (text.trim().toLowerCase().startsWith('<svg') || ct.indexOf('svg') !== -1 || mapPinIconUrl.toLowerCase().endsWith('.svg')) {
                        pinContentTemplate = new DOMParser().parseFromString(text, 'image/svg+xml').documentElement;
                    } else {
                        pinIsImg = true;
                        pinContentTemplate = { url: mapPinIconUrl };
                    }
                } catch (e) {
                    console.warn('LocationsMap: could not load map pin icon from URL', e);
                }
            }
            if (!pinContentTemplate && mapPinIconHtml) {
                try {
                    pinContentTemplate = new DOMParser().parseFromString(mapPinIconHtml, 'image/svg+xml').documentElement;
                } catch (e) {
                    console.warn('LocationsMap: could not parse mapPinIcon', e);
                }
            }

            locations.forEach(function (loc, locIdx) {
                let pinContent;
                if (pinIsImg && pinContentTemplate && pinContentTemplate.url) {
                    pinContent = document.createElement('img');
                    pinContent.src = pinContentTemplate.url;
                    pinContent.width = 29;
                    pinContent.height = 29;
                    pinContent.alt = '';
                } else if (pinContentTemplate && pinContentTemplate.cloneNode) {
                    pinContent = pinContentTemplate.cloneNode(true);
                }

                let marker = new AdvancedMarkerElement({
                    position: { lat: loc.lat, lng: loc.lng },
                    title: loc.title,
                    content: pinContent,
                    map: map,
                    gmpClickable: true
                });

                marker.addListener('gmp-click', function () {
                    openLocationPopup(loc, marker);
                    selectListItem(locIdx);
                });

                markers.push(marker);
            });

            let searchInput = self.querySelector('.locations-search__input');
            let searchButton = self.querySelector('.locations-search__button');
            let desktopList = self.querySelector('.locations-search__list');
            let mobileList = self.querySelector('.locations-search__list-container-mobile');

            if (!searchInput || (!desktopList && !mobileList)) return;

            let selectedTypeFilter = '';

            function locationMatchesSearch(loc, query) {
                if (!query) return true;
                let q = query.toLowerCase();
                return (loc.title && loc.title.toLowerCase().indexOf(q) !== -1) ||
                    (loc.address && loc.address.toLowerCase().indexOf(q) !== -1);
            }

            function locationMatchesType(loc) {
                if (!selectedTypeFilter) return true;
                let types = loc.store_type || [];
                return types.indexOf(selectedTypeFilter) !== -1;
            }

            function applyFilters() {
                let query = (searchInput && searchInput.value) ? searchInput.value.trim().toLowerCase() : '';
                if (query === '' && window.location.search.includes('page=')) {
                    let newUrl = new URL(window.location.href);
                    newUrl.searchParams.delete('page');
                    window.history.pushState({ path: newUrl.href }, '', newUrl.href);
                }
                for (let i = 0; i < locations.length; i++) {
                    let loc = locations[i];
                    let show = locationMatchesSearch(loc, query) && locationMatchesType(loc);
                    if (markers[i]) markers[i].map = show ? map : null;
                }
                function setListVisibility(listEl) {
                    if (!listEl) return;
                    let items = listEl.querySelectorAll('.locations-search__item');
                    for (let j = 0; j < items.length; j++) {
                        let idx = parseInt(items[j].getAttribute('data-loc-index'), 10);
                        let loc = locations[idx];
                        let show = loc && locationMatchesSearch(loc, query) && locationMatchesType(loc);
                        items[j].style.display = show ? '' : 'none';
                    }
                }
                setListVisibility(desktopList);
                setListVisibility(mobileList);
            }

            applyFilters();

            function selectListItem(idx) {
                function highlightInList(listEl) {
                    if (!listEl) return;
                    let prev = listEl.querySelector('.locations-search__item.is-active');
                    if (prev) prev.classList.remove('is-active');
                    let next = listEl.querySelector('.locations-search__item[data-loc-index="' + idx + '"]');
                    if (next) {
                        next.classList.add('is-active');
                        next.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                    }
                }
                highlightInList(desktopList);
                highlightInList(mobileList);
            }

            function onListItemClick(e) {
                if (e.target.tagName === 'A') return;
                let li = e.target.closest('.locations-search__item');
                if (!li) return;
                let idx = parseInt(li.getAttribute('data-loc-index'), 10);
                let loc = locations[idx];
                if (!loc || !markers[idx]) return;
                selectListItem(idx);
                openLocationPopup(loc, markers[idx], { panAndZoom: true });
            }

            if (desktopList) desktopList.addEventListener('click', onListItemClick);
            if (mobileList) mobileList.addEventListener('click', onListItemClick);

            searchInput.addEventListener('input', function () {
                applyFilters();
            });

            if (searchButton) {
                searchButton.addEventListener('click', function () {
                    applyFilters();
                });
            }

            let filterContainer = self.querySelector('.locations-search__list-filter');
            if (filterContainer) {
                let filterItems = filterContainer.querySelectorAll('.locations-search__list-filter-item');
                for (let f = 0; f < filterItems.length; f++) {
                    filterItems[f].addEventListener('click', function (e) {
                        selectedTypeFilter = this.getAttribute('data-filter-type') || '';
                        let allFilters = filterContainer.querySelectorAll('.locations-search__list-filter-item');
                        for (let s = 0; s < allFilters.length; s++) allFilters[s].classList.remove('is-active');
                        this.classList.add('is-active');
                        applyFilters();
                    });
                    filterItems[f].addEventListener('keydown', function (e) {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            this.click();
                        }
                    });
                }
            }

            let filterScrollEl = self.querySelector('.locations-search__list-filter-scroll');
            if (filterScrollEl) {
                let customPrevBtn = self.querySelector('.filter-scroll-prev');
                let customNextBtn = self.querySelector('.filter-scroll-next');
                if (customPrevBtn && customNextBtn) {
                    customPrevBtn.addEventListener('click', function () {
                        filterScrollEl.scrollBy({ left: -200, behavior: 'smooth' });
                    });
                    customNextBtn.addEventListener('click', function () {
                        filterScrollEl.scrollBy({ left: 200, behavior: 'smooth' });
                    });
                    function checkScrollButtons() {
                        let scrollLeft = filterScrollEl.scrollLeft;
                        let maxScroll = filterScrollEl.scrollWidth - filterScrollEl.clientWidth;
                        customPrevBtn.classList.toggle('location-nav-arrow--hidden', scrollLeft <= 5);
                        customNextBtn.classList.toggle('location-nav-arrow--hidden', scrollLeft >= maxScroll - 5 || maxScroll <= 0);
                    }
                    filterScrollEl.addEventListener('scroll', checkScrollButtons);
                    window.addEventListener('resize', checkScrollButtons);
                    checkScrollButtons();
                    setTimeout(checkScrollButtons, 100);
                }

                (function enableFilterMouseDrag() {
                    var startX, startScrollLeft, maxScroll, isDragging;
                    var rafId = null;
                    var pendingScrollLeft = null;

                    function preventClickOnce(e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }

                    function applyScroll() {
                        rafId = null;
                        if (pendingScrollLeft === null) return;
                        filterScrollEl.scrollLeft = pendingScrollLeft;
                        pendingScrollLeft = null;
                    }

                    filterScrollEl.addEventListener('mousedown', function (e) {
                        if (e.button !== 0) return;
                        startX = e.pageX;
                        startScrollLeft = filterScrollEl.scrollLeft;
                        maxScroll = filterScrollEl.scrollWidth - filterScrollEl.clientWidth;
                        isDragging = false;
                        pendingScrollLeft = null;
                        if (rafId !== null) cancelAnimationFrame(rafId);

                        function onMove(e) {
                            var dx = Math.abs(e.pageX - startX);
                            if (!isDragging && dx > 4) isDragging = true;
                            if (isDragging) {
                                var next = Math.max(0, Math.min(maxScroll, startScrollLeft + (startX - e.pageX)));
                                pendingScrollLeft = next;
                                if (rafId === null) rafId = requestAnimationFrame(applyScroll);
                            }
                        }

                        function onUp() {
                            document.removeEventListener('mousemove', onMove);
                            document.removeEventListener('mouseup', onUp);
                            filterScrollEl.classList.remove('locations-search__list-filter--dragging');
                            document.body.style.userSelect = '';
                            document.body.style.cursor = '';
                            if (rafId !== null) {
                                cancelAnimationFrame(rafId);
                                rafId = null;
                            }
                            if (pendingScrollLeft !== null) {
                                filterScrollEl.scrollLeft = pendingScrollLeft;
                                pendingScrollLeft = null;
                            }
                            if (isDragging) {
                                filterScrollEl.addEventListener('click', preventClickOnce, true);
                                setTimeout(function () {
                                    filterScrollEl.removeEventListener('click', preventClickOnce, true);
                                }, 0);
                            }
                        }

                        document.addEventListener('mousemove', onMove);
                        document.addEventListener('mouseup', onUp);
                        filterScrollEl.classList.add('locations-search__list-filter--dragging');
                        document.body.style.userSelect = 'none';
                        document.body.style.cursor = 'grabbing';
                    });
                })();
            }
        }
    }

    customElements.define('locations-map', LocationsMap);
}
